export default __webpack_public_path__ + "static/media/python.849d0b2b.svg";